import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { C, field, btnPrimary, softShadow } from "../lib/theme";
import { toast } from "sonner";
import { Store } from "lucide-react";

export default function RegisterRestaurant() {
  const { registerOwner } = useAuth();
  const nav = useNavigate();
  const [restaurantName, setRestaurantName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await registerOwner(name, email, password, restaurantName);
      toast.success("Ristorante registrato! Ora collega i pagamenti.");
      nav("/impostazioni");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md bg-white rounded-3xl p-8 sm:p-10" style={softShadow} data-testid="register-card">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-11 h-11 rounded-2xl flex items-center justify-center" style={{ background: C.CORAL }}>
            <Store className="w-6 h-6 text-white" />
          </span>
          <span className="font-display text-2xl font-extrabold" style={{ color: C.INK }}>Registra il tuo ristorante</span>
        </div>
        <p className="text-sm mb-8" style={{ color: C.MUTED }}>Crea il tuo account e inizia a ricevere prenotazioni con caparra.</p>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-sm font-semibold mb-2" style={{ color: "#4a453f" }}>Nome del ristorante</label>
            <input data-testid="reg-restaurant-name" required value={restaurantName} onChange={(e) => setRestaurantName(e.target.value)} className={field} placeholder="Osteria del Mare" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2" style={{ color: "#4a453f" }}>Il tuo nome</label>
            <input data-testid="reg-owner-name" required value={name} onChange={(e) => setName(e.target.value)} className={field} placeholder="Mario Rossi" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2" style={{ color: "#4a453f" }}>Email</label>
            <input data-testid="reg-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={field} placeholder="tu@ristorante.it" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2" style={{ color: "#4a453f" }}>Password</label>
            <input data-testid="reg-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className={field} placeholder="Min. 6 caratteri" />
          </div>
          <button data-testid="reg-submit" disabled={loading} className={`${btnPrimary} w-full`}>
            {loading ? "Creazione…" : "Crea ristorante"}
          </button>
        </form>
        <p className="text-sm mt-6 text-center" style={{ color: C.MUTED }}>
          Hai già un account?{" "}
          <Link to="/login" className="font-bold hover:underline" style={{ color: C.CORAL }}>Accedi</Link>
        </p>
      </div>
    </div>
  );
}
